import FieldSettings from './FieldSettings.component';

export default FieldSettings;
